module.exports = {
  route: {
    map: 'Map',
    dashboard: 'Dashboard',
    reports: 'Reports',
    report: 'Report',
    report_trip_title: 'Trip Report',
    report_location_title: 'Location Report',
    report_zone_crossing: 'Zone Report',
    report_speeding: 'Relatório de Excessos de Velocidade',
    report_speeding_beta: 'Relatório de Excessos de Velocidade BETA',
    report_tolls: 'Relatório de Portagens',
    settings: 'Settings',
    duration: 'Duration'
  },
  map: {
    geofence_create_title: 'New geofence',
    geofence_create_name: 'Please enter the name of this geofence...',
    geofence_created: 'Geofence created sucessfully!',
    geofence_create_canceled: 'Input canceled',
    poi_create_title: 'New POI',
    poi_create_name: 'Please enter the name of this POI...',
    poi_created: 'POI created sucessfully!',
    poi_create_canceled: 'Input canceled',
    create_confirm: 'OK',
    create_cancel: 'Cancel',
    loading: 'Loading',
    totalDistance: 'Distância total'
  },
  vehicleList: {
    title: 'Vehicle',
    search: 'Search...',
    column_name: 'Name',
    column_speed: 'Km/h',
    column_lastUpdate: 'Last update'
  },
  vehicleTable: {
    immobilize: 'Immobilize',
    de_immobilize: 'De-Immobilize',
    send_immobilization: 'Send immobilization command?',
    send_de_immobilization: 'Send de-immobilization command?',
    all_vehicles: 'All',
    moving_vehicles: 'Moving',
    idle_vehicles: 'Idle',
    stopped_vehicles: 'Stopped',
    disconnected_vehicles: 'Disconnected'
  },
  vehicleDetail: {
    show_route: 'Show route'
  },
  poiTable: {
    showPOIs: 'Show POIs',
    edit_poi: 'Edit',
    delete_poi: 'Delete'
  },
  dashboard: {
    startdate: 'Start date',
    enddate: 'End Date',
    period_lastweek: 'Last week',
    period_lastmonth: 'Last month',
    period_last3month: 'Last 3 months'
  },
  navbar: {
    profile: 'Profile',
    notifications: 'Notifications',
    settings: 'Settings',
    logout: 'Log Out'
  },
  login: {
    login_user: 'Email',
    login_password: 'Password',
    login_button: 'Login',
    login_password_warn: 'The password can not be less than 6 digits'
  },
  profile: {
    user_account: 'Account',
    user_name: 'Name',
    user_email: 'E-mail',
    user_password: 'Password',
    user_phone: 'Phone',
    user_language: 'Language',
    user_timezone: 'Timezone',
    user_update_button: 'Update',
    user_updated: 'User information has been updated successfully.',
    user_name_required: 'Name field is required',
    user_email_required: 'Please input a valid email',
    user_password_lengh: 'The password can not be less than 6 digits'
  },
  settings: {
    map: 'Map',
    vehicles: 'Vehicles',
    title: 'Settings',
    route_match: 'Route match',
    alerts: 'Alerts',
    alerts_type: 'Type',
    alerts_notificators: 'Notificators',
    alert_ignitionOff: 'Ignition Off',
    alert_ignitionOn: 'Ignition On',
    alert_geofenceEnter: 'Geofence Enter',
    alert_geofenceExit: 'Geofence Exit',
    alert_deviceOverspeed: 'Device Overspeed',
    alert_deleted: 'Alert has been deleted',
    alert_delete_info: 'Do you want to delete the alert ',
    alert_delete_title: 'Delete Alert',
    alert_edit_confirm: 'Confirm',
    alert_edit_cancel: 'Cancel',
    alert_created: 'Alert created sucessfully!',
    alert_updated: 'Alert updated sucessfully!',
    alert_add: 'Add Alert',
    alert_edit: 'Edit Alert',
    alert_delete: 'Delete Alert',
    alert_overspeed_warning: 'Vehicle without defined top speed',
    alert_geofences_warning: 'Vehicle without associated geofences',
    alert_associate_geofences: 'Associate Geofences',
    alert_form_type: 'Type:',
    alert_form_type_placeholder: 'Select alert type',
    alert_form_vehicles: 'Vehicles:',
    alert_form_geofences: 'Geofences:',
    alert_form_all_vehicles: 'All vehicles',
    alert_form_vehicles_placeholder: 'Select vehicles',
    alert_form_notificator_web: 'Web',
    alert_form_notificator_email: 'E-mail',
    alert_form_notificator_sms: 'SMS',
    alert_form_confirm: 'Save',
    alert_form_cancel: 'Cancel',
    alert_form_geofences_placeholder: 'Select geofences',
    vehicle_edit: 'Edit Vehicle',
    vehicle_name: 'Name',
    vehicle_licenseplate: 'License Plate',
    vehicle_model: 'Model',
    vehicle_speed_limit: 'Speed Limit',
    vehicle_form_cancel: 'Cancel',
    vehicle_form_confirm: 'Save',
    vehicle_form_name: 'Name',
    vehicle_form_model: 'Model',
    vehicle_form_speed_limit: 'Speed Limit (Km/h)',
    vehicle_updated: 'Vehicle updated sucessfully!'
  },
  geofence: {
    showGeofences: 'Show Geofences',
    geofence_name: 'Name',
    geofence_edit: 'Edit',
    geofence_delete: 'Delete',
    geofence_deleted: 'Geofence has been deleted',
    geofence_delete_info: 'Do you want to delete geofence ',
    geofence_delete_title: 'Delete Geofence',
    geofence_edit_title: 'Edit Geofence',
    geofence_edit_name: 'Please enter the name of this geofence...',
    geofence_edit_confirm: 'Confirm',
    geofence_edit_cancel: 'Cancel',
    geofence_edit_canceled: 'Edit canceled',
    geofence_edited: 'Geofence edited sucessfully!',
    poi_delete_info: 'Do you want to delete POI ',
    poi_delete_title: 'Delete POI',
    poi_edited: 'POI edited sucessfully!',
    poi_deleted: 'POI has been deleted',
    poi_edit_title: 'Edit POI',
    poi_edit_name: 'Please enter the name of this POI...',
    searchGeofence: 'Search geofence',
    edit_geofence: 'Edit',
    delete_geofence: 'Delete'
  },
  report: {
    alarm: 'Alarm',
    distanceIn: 'Kms inside',
    distanceOut: 'Kms outside',
    closed: 'Door Closed',
    opened: 'Door Opened',
    sun: 'Sun',
    rain: 'Rain',
    temperature: 'Temperatura',
    select_vehicles: 'Select vehicles',
    select_vehicles_placeholder: 'Vehicles',
    select_geofences: 'Select geofences',
    select_geofences_placeholder: 'Geofences',
    select_period: 'Select period',
    period: 'Period',
    date_start: 'Start date',
    date_end: 'End date',
    generate_report: 'Generate report',
    validate_period: 'Por favor seleccione o período',
    user: 'User',
    titleTripReport: 'Trip Report',
    titleLocationReport: 'Locations Report',
    titleSpeedingReport: 'Overspeed Report',
    titleZoneReport: 'Zone Report',
    titleRefuelingReport: 'Refueling Report',
    titleFuelConsumptionReport: 'Fuel Consumption Report',
    titleFuelDropReport: 'Fuel Drop Report',
    titleEventsReport: 'Events Report',
    titleActivityReport: 'Activity Report',
    titleKmsReport: 'Kms Report',
    titleIdleReport: 'Idle Report',
    titleMachinesReport: 'Machines Report',
    titleStopReport: 'Stop Report',
    titleSensorReport: 'Sensor Report',
    from: 'From',
    to: 'to',
    headerStartAddress: 'Start address',
    headerDistance: 'Distance',
    headerDrivingTime: 'Driving Time',
    headerMaxSpeed: 'Max Speed',
    date: 'Date',
    start: 'Start',
    end: 'End',
    stopped: 'Stopped',
    yes: 'Yes',
    no: 'No',
    endAddress: 'Destination',
    tripTime: 'Duration',
    idleTime: 'Idle',
    stopTime: 'Stop',
    distance: 'Distance',
    speed: 'Speed',
    roadSpeedLimit: 'Road Speed Limit',
    overspeed: 'Alert On',
    avgSpeed: 'Avg Speed',
    maxSpeed: 'Max Speed',
    driver: 'Driver',
    group: 'Group',
    address: 'Address',
    ignition: 'Ignition',
    ignitionOn: 'On',
    ignitionOff: 'Off',
    enter: 'Enter',
    exit: 'Exit',
    geofence: 'Geofence',
    duration: 'Duration',
    vehicles: 'Vehicles',
    vehicle: 'Vehicle',
    licensePlate: 'License Plate',
    consumption: 'Consumption (L)',
    avg_consumption: 'Avg. Consumption (L/100)',
    avg_consumption_by_liters: 'Avg. Consumption (Kms/L)',
    odometer: 'Odometer',
    startOdometer: 'Start (Km)',
    endOdometer: 'End (Km)',
    spentFuel: 'Spent Fuel',
    engineHours: 'Use (H:m)',
    totalEngineHours: 'Total Use (H:m)',
    driverHours: 'Driving Time (H:m)',
    refueling: 'Refueling',
    fueldrop: 'Fuel Drop (L)',
    totalRefueled: 'Total Refueled',
    totalFuelDrops: 'Total Fuel Drops',
    totalFuelDropLiters: 'Total Fuel Lost',
    speedLimit: 'Speed Limit',
    eventType: 'Event',
    info: 'Information',
    event_ignitionOff: 'Ignition Off',
    event_ignitionOn: 'Ignition On',
    event_deviceOverspeed: 'Device Overspeed',
    event_geofenceEnter: 'Geofence Enter',
    event_geofenceExit: 'Geofence Exit',
    event_deviceFuelDrop: 'Fuel Drop',
    event_driverChanged: 'Driver Changed',
    event_sos: 'SOS',
    event_powerOn: 'Power TakeOff',
    event_powerCute: 'Power Cut',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    weekDay: 'Week Day',
    unsubscribeTripReport: 'If you no longer wish to receive these emails, please go to %url% and remove the option "Trip report" in the settings in the "Reports" section.',
    unsubscribeLocationsReport: 'If you no longer wish to receive these emails, please go to %url% and remove the option "Locations report" in the settings in the "Reports" section.',
    unsubscribeSpeedingReport: 'If you no longer wish to receive these emails, please go to %url% and remove the option "Overspeed report" in the settings in the "Reports" section.',
    unsubscribeZoneReport: 'If you no longer wish to receive these emails, please go to %url% and remove the option "Zone report" in the settings in the "Reports" section.',
    unsubscribeRefuelingReport: 'If you no longer wish to receive these emails, please go to %url% and remove the option "Refueling report" in the settings in the "Reports" section.',
    unsubscribeFuelDropReport: 'If you no longer wish to receive these emails, please go to %url% and remove the option "Fuel drop report" in the settings in the "Reports" section.',
    minimumMinutes: 'Minimum time',
    maximumSpeed: 'Maximum speed',
    minutes: 'Minutes',
    zone: 'Zone',
    firstIn: 'First In',
    lastOut: 'Last Out',
    timeIn: 'Time In',
    timeOut: 'Time Out',
    maxTemp: 'Max Temp',
    minTemp: 'Min Temp',
    avgTemp: 'Avg Temp',
    total: 'Total'
  },
  layout: {
    deviceOnline: 'Device Online',
    deviceMoving: 'Device Moving',
    deviceStopped: 'Device Stopped',
    ignitionOff: 'Ignition Off',
    ignitionOn: 'Ignition On',
    deviceOverspeed: 'Device Overspeed',
    geofenceEnter: 'Geofence Enter',
    geofenceExit: 'Geofence Exit',
    deviceFuelDrop: 'Fuel Drop',
    driverChanged: 'Driver Changed',
    test: 'Test Notification',
    sos: 'Panic',
    powerOn: 'Power Take-Off',
    device: 'Device',
    time: 'Time',
    address: 'Address',
    driver: 'Driver',
    group: 'Group',
    in: 'in',
    fuelDropInfo: 'Fuel drop greater than '
  }
}
